import { useState, useCallback, useEffect } from 'react';

/**
 * Custom hook para manejo de scanner QR
 * Encapsula la lógica de escaneo y estado del scanner
 */
export const useQRScanner = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [scanningFor, setScanningFor] = useState(null);
  const [lastScanned, setLastScanned] = useState(null);
  const [error, setError] = useState(null);

  const startScanning = useCallback((fieldName) => {
    setIsScanning(true);
    setScanningFor(fieldName);
    setError(null);
  }, []);

  const stopScanning = useCallback(() => {
    setIsScanning(false);
    setScanningFor(null);
    setError(null);
  }, []);

  const handleScanSuccess = useCallback((decodedText, onSuccess) => {
    setLastScanned({
      text: decodedText,
      field: scanningFor,
      timestamp: new Date(),
    });
    
    if (onSuccess) {
      onSuccess(scanningFor, decodedText);
    }
    
    stopScanning();
  }, [scanningFor, stopScanning]);

  const handleScanError = useCallback((err) => {
    // Solo log errores no triviales
    if (err && !err.includes('NotFoundException')) {
      console.error('QR Scan error:', err);
      setError(err);
    }
  }, []);

  const clearLastScanned = useCallback(() => {
    setLastScanned(null);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (isScanning) {
        stopScanning();
      }
    };
  }, [isScanning, stopScanning]);

  return {
    isScanning,
    scanningFor,
    lastScanned,
    error,
    startScanning,
    stopScanning,
    handleScanSuccess,
    handleScanError,
    clearLastScanned,
  };
};

export default useQRScanner;
